__turbopack_context__.v({
  "after": "product-value-prop-section-module__fyUTVW__after",
  "arrow": "product-value-prop-section-module__fyUTVW__arrow",
  "audience": "product-value-prop-section-module__fyUTVW__audience",
  "before": "product-value-prop-section-module__fyUTVW__before",
  "benefitIcon": "product-value-prop-section-module__fyUTVW__benefitIcon",
  "benefitRow": "product-value-prop-section-module__fyUTVW__benefitRow",
  "benefitRows": "product-value-prop-section-module__fyUTVW__benefitRows",
  "comparison": "product-value-prop-section-module__fyUTVW__comparison",
  "connected": "product-value-prop-section-module__fyUTVW__connected",
  "panel": "product-value-prop-section-module__fyUTVW__panel",
  "title": "product-value-prop-section-module__fyUTVW__title",
});
